import { BottomTabBar } from "@/components/BottomTabBar";

export const AppShell = ({ title, right, children }) => (
  <div className="min-h-screen bg-ho-bg pb-28">
    <header className="sticky top-0 z-30 border-b border-black/5 bg-ho-bg/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-md items-center justify-between px-5 py-4">
        <h1 className="font-display text-2xl font-extrabold tracking-tight">{title}</h1>
        {right}
      </div>
    </header>
    <div className="mx-auto max-w-md px-5 pt-4">{children}</div>
    <BottomTabBar />
  </div>
);
